export const SplitHeroTheme = {
  brand: {
    background: 'bg-brand-strongest',
    headingText: 'text-brand-base',
    subheadingText: 'text-on-screen-surface-dark',
    videoButtonBackground: 'bg-brand-base'
  },
  grape: {
    background: 'bg-accent1-strongest',
    headingText: 'text-accent1-base',
    subheadingText: 'text-on-screen-surface-dark',
    videoButtonBackground: 'bg-accent1-base'
  },
  lagoon: {
    background: 'bg-[#00364D]',
    headingText: 'text-accent2-base',
    subheadingText: 'text-on-screen-surface-dark',
    videoButtonBackground: 'bg-accent2-base'
  },
  lime: {
    background: 'bg-accent3-strongest',
    headingText: 'text-accent3-base',
    subheadingText: 'text-on-screen-surface-dark',
    videoButtonBackground: 'bg-accent3-base'
  },
  piggybank: {
    background: 'bg-[#581226]',
    headingText: 'text-accent5-base',
    subheadingText: 'text-on-screen-surface-dark',
    videoButtonBackground: 'bg-accent5-base'
  },
  tangerine: {
    background: 'bg-accent4-strongest',
    headingText: 'text-accent4-base',
    subheadingText: 'text-on-screen-surface-dark',
    videoButtonBackground: 'bg-accent4-base'
  },
  default: {
    background: 'bg-warm-neutral-100',
    headingText: 'text-on-supplementary',
    subheadingText: 'text-on-primary-surface',
    videoButtonBackground: 'bg-brand-base'
  }
} as const;

export type SplitHeroThemeType = keyof typeof SplitHeroTheme;

export const getSplitHeroThemeClasses = (theme?: string) => {
  if (!theme) {
    return {
      background: 'bg-brand-strongest',
      headingText: 'text-brand-base',
      subheadingText: 'text-on-screen-surface-dark',
      videoButtonBackground: 'bg-brand-base'
    };
  }

  const themeKey = Object.prototype.hasOwnProperty.call(
    SplitHeroTheme,
    theme as PropertyKey
  )
    ? (theme as SplitHeroThemeType)
    : 'brand';

  return SplitHeroTheme[themeKey];
};
